import React from 'react';
import { BarChart } from '@mui/x-charts/BarChart';
import { Card, CardContent, Typography, Box } from '@mui/material';

interface ComparisonData {
  todayClaims: number;
  yesterdayClaims: number;
  todayLocs: number;
  yesterdayLocs: number;
  todayResponses: number;
  yesterdayResponses: number;
}

interface ClaimsComparisonChartProps {
  data: ComparisonData;
  loading?: boolean;
}

const ClaimsComparisonChart: React.FC<ClaimsComparisonChartProps> = ({ data, loading }) => {

  if (loading) {
    return (
      <Card sx={{ height: '100%' }}>
        <CardContent>
          <Box sx={{ height: 300, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
            <Typography color="text.secondary">Loading comparison data...</Typography>
          </Box>
        </CardContent>
      </Card>
    );
  }

  const chartData = [
    {
      metric: 'Claims',
      today: data.todayClaims,
      yesterday: data.yesterdayClaims,
    },
    {
      metric: 'LOCs Sent',
      today: data.todayLocs,
      yesterday: data.yesterdayLocs,
    },
    {
      metric: 'Responses',
      today: data.todayResponses,
      yesterday: data.yesterdayResponses,
    },
  ];

  return (
    <Card sx={{ height: '100%' }}>
      <CardContent>
        <Typography variant="h6" gutterBottom>
          Today vs Yesterday
        </Typography>
        <Box sx={{ width: '100%', height: 300 }}>
          <BarChart
            dataset={chartData}
            series={[
              { 
                dataKey: 'today', 
                label: 'Today',
                color: '#007bff'
              },
              { 
                dataKey: 'yesterday', 
                label: 'Yesterday',
                color: '#6c757d'
              },
            ]}
            xAxis={[
              {
                dataKey: 'metric',
                scaleType: 'band',
              },
            ]}
            yAxis={[
              {
                min: 0,
              },
            ]}
            slotProps={{
              legend: {
                direction: 'row' as any,
                position: { vertical: 'top', horizontal: 'center' },
              },
            }}
            margin={{ left: 50, right: 20, top: 60, bottom: 30 }}
          />
        </Box>
      </CardContent>
    </Card>
  );
};

export default ClaimsComparisonChart;